const cardDatas = [
  {
    id: 1,
    title: 'Business',
    description: 'SUN, OCT 24 @ 1:15 AM ICT',
    description1: 'How to make your business growth 10 times within 1 year',
    description2: 'By Adit nento',
    img: 'https://s3-alpha-sig.figma.com/img/9568/ceda/08c92da8d94729fd2bf373c902589f2d?Expires=1638748800&Signature=WCq4-ALQ0~TCVWnpVjdgqup-TdRXeoVSBGmaLC4zErfMhhwN6xjeIKFdzkwITeEaHonoc-Ks1fQ8zWxJ8uI54e91I5TcZmlLvMtpqzuqetBsCxZmPQroEOM77BUYs83n47dNrwaqUIOGqh3Ne3AcmEN7te0~K1oga6eeBsaDP4wVq9px5sH6jAEbj3IZ30noD912TPKwhDAtk9AZhb-w~t9t3KFKssSIcbsn~XtXwwLnjU5cWCq8Q8re9S9mF1hR65qKh5TpPCb-GQGa~aE8MdCeaLeI~QnKrtDqDDasmQi2b9xuAL25YX802xN8zEhZde6~K-Di22DnCh~4oDEvEQ__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA',
  },
  {
    id: 2,
    title: 'Design',
    description: 'SUN, OCT 24 @ 1:15 AM ICT',
    description1: 'Hitting Reset: How to ladn A Job in UX Design',
    description2: 'By Ernest',
    img: 'https://s3-alpha-sig.figma.com/img/02d1/31cd/97a20b34d4c259133af7a6300eeaea07?Expires=1638748800&Signature=HwOi3Z0YMibzik4uSQ2teF70oSvzXGJd4bj~DGgF8jypzInGlT5hb0b2RMbhTxlNUZPCcIL31OX7G3SlaSbGk5S2~~ttmNFmet2OXAs7eThwOt6fzfBSoEVMbLsGpJXYNJbFcHFKX90~KcXcbHm-9TfrqfKS1SKtF-lCFKClNzvojlvFGlCXuYG66pZg7owx1ZOKVm7JjUsGHnoSycb4cvSApN3vDiXMuHx1f-KiMLqf3V6zeYH7F93dZ7rAqyF9ZK1568bDk4Uu6zSlb~MKyTLemeOCc6VLUvLrizSRPSwpr7zSxFhsMc8NiTLKe-Es5oV0ruvRHygPqu8xys8dyw__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA',
  },
  {
    id: 3,
    title: 'Marketing',
    description: 'SUN, OCT 24 @ 1:15 AM ICT',
    description1: 'Google Ads 101 with the best marketing agency',
    description2: 'By budi Setiawan',
    img: 'https://s3-alpha-sig.figma.com/img/ba7c/4f70/c12a349ad9b3edc4112fe0e250c81703?Expires=1638748800&Signature=Y-3Q-ZFjf0I53g7EcCMPaMRtpq1tiNKZSLRN6Vxk7eVUB3QjxhoawVwtLvVXGOgRDQEYOpIooEDeI3qd5uXjGE6FMkXDBEOXbG8yUVo~x9In2qQ0E3E-hNn7eIX9VBFjpIHYQn~pHeC3r2zxIybz11YHqRDZPWDCty88kwquqrPnRMYLOep5Hx-EBuUM8b02Tz~MZ9fDJM4bPWjcMKSNHLQp0~wwtoLEbyOnXeoDjfjUW8grGd1Kw-lJT2pBs4~hhBY0af2wmSyzmvgThKnBpfasnyuexyxx7xdMaNAhywS0qhHxk0LUmGq5GkzU-IEVZXghP8kr6kCGJ05GcpkGdQ__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA',
  },
  {
    id: 4,
    title: 'Design',
    description: 'SUN, OCT 24 @ 1:15 AM ICT',
    description1: 'How to create a design system',
    description2: 'By Agung Dwi Putra',
    img: 'https://s3-alpha-sig.figma.com/img/788d/47f4/503780411503b39c7c618d4fdc640178?Expires=1638748800&Signature=LV8A4FGK~BFu9Xtan5D8X0pCZXGC8A7M2YLOJXOM0i7SKdIZAhkS0GVoU~dvgE9pJZq0d6BaIBXSKU1YSfH0ANiqYtlulveWuVTlHyutrBy55Rw6Y7i-RuWL-7IiTbBYAzUfQNtpbCI-woRuw1aIJzcMgBku~i3m-xfIMBUErE0w0Nd8Sk-oYHMnnXVp8nKeSWYNR9jQKV~BR3MbfJJ39SEgBzuCbw5VrdYsR7ygygxOlNsic1zoC-3WiCcgmGvBgUwMiibHY1egGZL-L232HbgD2LYMk7H-lzrtMNU9rj~yVC-pvXv-p7X8EwQqN9RE4NahHiOUJsJU4Ep~lMTqoQ__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA',
  },
];
export default cardDatas;
